import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

type NativeContainerProps = BoxProps & {
  isNative?: boolean;
};

export const GeneralTopContainer = ({ isNative, style, ...props }: NativeContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.generalTopContainer, isNative && styles.generalTopContainerNative, style],
  });

export const GeneralBottomContainer = ({ isNative, style, ...props }: NativeContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.generalBottomContainer, isNative && styles.generalBottomContainerNative, style],
  });

export const LeftButtonOne = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.leftButtonOne, style] });

export const LeftButtonTwo = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.leftButtonTwo, style] });

export const LeftButtonThree = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.leftButtonThree, style] });

export const RightButton = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.rightButton, style] });

export const InnerWhiteContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.innerWhiteContainer, style] });

export const InnerGrayContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.innerGrayContainer, style] });

export const WalmartLogoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.walmartLogoContainer, style] });

export const InnerBottomContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.innerBottomContainer, isDesktop && styles.innerBottomContainerDesktop, style],
  });
};

const styles = StyleSheet.create({
  generalTopContainer: {
    backgroundColor: primitive.$blueWalmart,
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: spacing.$2_5,
    paddingTop: spacing.$10,
  },
  generalTopContainerNative: {
    paddingTop: spacing.$20,
  },
  generalBottomContainer: {
    alignItems: 'center',
    paddingBottom: 25,
    paddingTop: 25,
  },
  generalBottomContainerNative: {
    paddingBottom: 80,
  },
  leftButtonOne: {
    backgroundColor: primitive.$white,
    height: 23,
    marginTop: 100,
    width: 1,
  },
  leftButtonTwo: {
    backgroundColor: primitive.$white,
    height: 50,
    marginTop: spacing.$8,
    width: 1,
  },
  leftButtonThree: {
    backgroundColor: primitive.$white,
    height: 50,
    marginTop: spacing.$2_5,
    width: 1,
  },
  rightButton: {
    backgroundColor: primitive.$white,
    height: 70,
    marginTop: 190,
    width: 1,
  },
  innerWhiteContainer: {
    borderBottomWidth: 0,
    borderColor: primitive.$white,
    borderTopLeftRadius: 52,
    borderTopRightRadius: 52,
    borderWidth: 5,
    height: 400,
    width: 306,
  },
  innerGrayContainer: {
    borderBottomWidth: 0,
    borderColor: '#D2D2D9',
    borderTopLeftRadius: 46,
    borderTopRightRadius: 46,
    borderWidth: 10,
    height: 395,
    width: 296,
  },
  walmartLogoContainer: {
    alignItems: 'center',
    backgroundColor: primitive.$white,
    borderRadius: 34,
    height: 52,
    justifyContent: 'center',
    left: 60,
    position: 'absolute',
    top: 320,
    width: 140,
  },
  innerBottomContainer: {
    paddingHorizontal: spacing.$2,
  },
  innerBottomContainerDesktop: {
    paddingHorizontal: spacing.$8,
  },
});
